<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"><HeaderContent /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 动态详情 -->
      <div class="dynamic_details">
        <h1>进军蓝海市场，WIDEN桅灯智能如何生存？</h1>
        <p class="author">
          <!-- <span
            ><img src="~@/assets/images/nameyu.jpg" />于斌<img
              src="~@/assets/images/v.png"
            /><a>| 于我所见，影响能影响的人。</a></span
          ><span>2021/08/11 11:17</span> -->
          <span>2021/08/11 11:17</span>
        </p>
        <!-- <h3>编辑 | 于斌</h3> -->
        <!-- <h3>出品 | 潮起网「于见专栏」</h3> -->
        <p>
          近年来，物联网行业越来越热，随着5G技术的落地与实现，物联网的发展更是达到了新的高度。当前，整个物联网市场都处在急速膨胀当中，参与者众多，行业涵盖广泛，物联网产品涉及内容也十分复杂。
        </p>
        <br /><br />
        <p>
          新的用户需求、新的创新技术和新的品牌巨头都在驱动着物联网行业的发展，在这样激烈的竞争之中，一家物联网创业公司WIDEN桅灯智能于2017年12月成立后也奔入了物联网行业的浪潮之中。WIDEN桅灯智能的主攻领域定位在了“智慧居家”与“智慧城市”之间的“公共空间”，主要面对B端业务，独特的发展定位也令外界对其有所期待。
        </p>
        <br /><br />
        <p>
          但是，在无论是行业巨头还是创业公司都纷纷入局物联网行业胜景之下，WIDEN桅灯智能究竟是能够走出差异化之路，还是被淹没在物联网行业的滚滚巨浪之中呢？答案恐怕还是有待考量。
        </p>
        <h3>进军蓝海领域，WIDEN桅灯智能或成炮灰</h3>
        <p>
          纵观物联网发展大方向，目前主要物联网智慧建设主要包括两大类别
          。第一类是城市空间的智慧建设，例如阿里、百度、科大讯飞等企业致力于智慧城市场景；第二类是居家空间的智慧建设，例如华为、美的、小米等企业专注在智能家居场景。
        </p>
        <p>
          而创业公司WIDEN桅灯智能想要在城市和居家之间的公共空间智慧建设之中谋求差异化之路。主攻领域包括例如产业园区、社区、医院、学校等半开放式的公共空间。
        </p>
        <div><img src="~@/assets/images/companyDynamics1.png" /></div>
        <br /><br />
        <p>
          不难看出，WIDEN桅灯智能想要进军的是一个还没有什么参与者在做的蓝海领域，这也令人十分担忧，这样一家几十人体量的小公司真的能够按照预想突击蓝海领域，走出自己的差异化之路吗？
        </p>
        <br /><br />
        <p>
          从WIDEN桅灯智能的现状及发展来看，从17年12月成立后直到19年里，整个公司只有一支体量较小的团队一直进行着平台产品的研发工作。
        </p>
        <br /><br />
        <p>
          成立后将近两年的时间里，在产品研发方面WIDEN桅灯智能可以被说是一无所获，2020年之后，也仅仅推出了一个名为CNS智能中枢系统1.0版本的产品，但这一产品也并没有在业内激起太大的水花。
        </p>
        <br /><br />
        <p>
          显然，在半开放的公共空间智慧建设这一蓝海前沿领域，WIDEN桅灯智能的小身材还是难以想期待的一样迸发出巨大的能量。
        </p>
        <br /><br />
        <p>
          这样的结果也不免引人深思，当一个市场完全没有人做的情况下，是不是这个市场不值得去做呢？又或者以目前的科技发展来说，这样的市场恐怕是难以驾驭的呢？无论如何，就目前而言，WIDEN桅灯智能的发展着实令人忧心。
        </p>
        <br /><br />
        <p>
          事实上，受新冠肺炎疫情影响，企业和政府部门都在办公和日常生活中增强了互联网、物联网和数字设备的使用，据悉，即使疫情消退，这种高水平的数字化仍将保持。从长期来看，疫情将加强人们对物联网的依赖。
        </p>
        <br /><br />
        <p>
          这对于各个物联网公司而言，虽然是一个巨大的挑战，但也无疑是发展的良机。例如，进军物联网行业的广和通便秉持着“疫情虽然是危，但危中也有机”的信念，迅速承接了广泛的物联网无线通信模组市场需求，抓住机会，进一步加大新技术、新产品的研发投入，不仅营收大幅上涨，股价也扶摇直上。
        </p>
        <br /><br />
        <p>
          反观WIDEN桅灯智能，在疫情期间的发展就显得十分乏力。且不说在无产品推出之前，大有闭门造车之势，研发的CNS智能中枢系统1.0版本在推出之后更多的方式也只是打包给园区使用或做一些技术支持，没有后期增加更多的技术投入，错过了疫情带给互联网企业的转机，发展呈现出了疲软状态。
        </p>
        <br /><br />
        <p>
          另外，WIDEN桅灯智能给出的定位是一家人工智能视觉识别服务提供商，基于深度学习，研发人脸识别、步态识别、人形识别、物体识别等计算机视觉技术产品，为智慧商业、智慧社区、智慧通行提供全方位AI解决方案。
        </p>
        <br /><br />
        <p>
          然而WIDEN桅灯智能作为一个发展近3年，还获得了3轮融资的的物联网公司，目前却仅仅推出了CNS智能中枢1.0版本这一个产品，功能上也与其定位所说相距甚远，从技术上来看确实水分不少，有言过其实之嫌。
        </p>
        <br /><br />
        <p>
          与国际性跨国大企业和国内大型科技集团的前瞻性及极强的研发能力相比，创业公司自主研发难、技术“失声”是WIDEN桅灯智能可持续发展过程中面临的重大阻碍之一。想要在物联网行业深耕，等待WIDEN桅灯智能还有人才、资金和技术三座大山。
        </p>
        <br /><br />
        <p>
          目前来看，WIDEN桅灯智能所处赛道，没有成熟的企业领跑，作为创业公司在技术研发上面临的困难确实不言而喻。其次，就人才来说，WIDEN桅灯智能目前主要涵盖的是计算机和建筑类的人才，想要继续在人工智能等方面继续深挖的话，仅依靠目前的人才储备还是远远不够。
        </p>
        <br /><br />
        <p>
          科技迭代升级，行业发展瞬息万变，WIDEN桅灯智能在应对变化，顺势而为上的表现不尽人意。只身投入蓝海领域的WIDEN桅灯智能梦想很大却未能照进现实，公司定位是否恰当，未来发展过程中会不会轮为物联网行业炮灰？不免让人为WIDEN桅灯智能的未来发展捏一把汗。
        </p>
        <h3>个人隐私、数据安全，WIDEN桅灯智能发展受阻</h3>
        <br /><br />
        <p>
          “设想一下，早上九点开车上班，进入停车场的同时，车牌识别系统中枢已经提前将电梯停至负一楼，办公室空调也已打开，只等你安心进入办公状态。”这是WIDEN桅灯智能在宣传中写出的未来致力于实现的设想场景。
        </p>
        <br /><br />
        <p>
          从这一场景中可以看到，WIDEN桅灯智能对于万物互联的高追求，但是也仅在这一个小小的设定场景就能看到，平台会访问你的数据库、个人状态，甚至是每天GPS行进的路径和停留地点。这将体现着WIDEN桅灯智能未来发展规划中对于用户个人隐私数据的超高度需求体现的淋漓尽致。
        </p>
        <br /><br />
        <div><img src="~@/assets/images/dynamicDetail22.jpg" /></div>
        <p>
          然而近几年，广大用户对于个人隐私和数据安全问题的重视程度越来越高，越来越多的用户甚至在下载APP时都普遍不愿意轻易赋予手机定位、访问通讯录等等权限。用户们谈数据色变，在各大媒体上广泛发声，物联网时代，求求企业别再“偷”老百姓的数据了。
        </p>
        <br /><br />
        <p>
          海默科技董事长窦剑文提到：“数据的安全和隐私是一个需要一直去研究和解决的问题，它与用户的使用意愿相关，在推广过程中是非常重要的话题，也是从开发、技术的角度要重点考虑的问题。”
        </p>
        <br /><br />
        <p>
          更何况，不同于阿里、华为这类大企业有广泛的国民接受度，用户对于WIDEN桅灯智能这类新兴创业公司的信任度相对较低，并且其主要投放的公共空间市场对于用户行踪轨迹数据的覆盖面更广，用户的质疑进而导致了依靠用户数据进行互通布局的WIDEN桅灯智能发展难免受阻。
        </p>
        <br /><br />
        <p>
          此外，万科集团执行副总裁张旭曾在研讨会上说：”服务业会涉及很多的隐私，所以需要非常严肃的考虑安全保护措施。当然，哪些数据能采集，哪些不能采集，我想我们要有基本的原则。能够公开、透明、可讨论的数据才可以采集，这是我们对待客户隐私的基本底线。“
        </p>
        <br /><br />
        <p>
          用户的数据是真实的、相对隐秘的，所以企业内部的网络安全、数据安全、数据访问就需要有非常严格的管理机制和技术手段。但是目前来看，WIDEN桅灯智能并没有对外公布其是否能够严格保证用户的个人隐私和数据安全，这令广大用户忧心忡忡。
        </p>
        <br /><br />
        <p>
          众所周知，物联网行业需要依靠数据进行迭代更近，在为客户提供定制方案时，数据越多，才能越好地个性化针对客户的优化点提供定制化的方案。一旦无法获取用户信任，WIDEN桅灯智能就会面临发展不稳的窘境。
        </p>
        <br /><br />
        <p>
          如何在用户“谈数据色变”的时代进行公共空间智慧建设的物联网布局，是WIDEN桅灯智能面临的迫切问题。无论是用户还是投资方都等待着WIDEN桅灯智能能够公布一个值得信赖的用户数据安全保护机制。
        </p>
        <br /><br />
        <p>
          如何深耕公共空间的智慧建设，如何应对个人隐私、数据安全问题，目前在蓝海领域挣扎前行的WIDEN桅灯智能是时候冷静思考一下了，在以数据为驱动，依靠用户信赖的物联网行业任凭产品再花式，功能再强大，没有用户，物联网平台终将成为无根之木。
        </p>
        <br /><br />
        <h3>结语</h3>
        <p>
          物联网行业崛起迅速，滚滚巨浪，各企业擅长领域和发展重点虽然有所差异，但相似领域之间同质化强，竞争压力大，牺牲品众多。每个公司都想要顺风而起，在这样的行业大环境中，想要深耕公共空间智慧建设的WIDEN桅灯智能能够异军突起扶摇直上吗？还是在无人问津的蓝海领域之中逐渐稀释瓦解呢？
        </p>
        <br /><br />
        <p>
          无论怎么样，物联网都将是下一个推动世界高速发展的重要生产力，公共空间的智慧建设在未来也有一定的应用市场，作为有一定技术基础的WIDEN桅灯智能团队自然不会坐以待毙。期待着WIDEN桅灯智能能够提升技术创新，找到发展之路，为我国物联网建设添砖加瓦，走向光明前途。
        </p>
        <br /><br />
      </div>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  background: #f8fafc;
  .dynamic_details {
    // margin: 62px 260px 53px 260px;
    margin: 62px 232px 53px 254px;
    padding: 55px 67px 74px 61px;
    background: #fff;
    text-align: left;
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 16px;
      line-height: 32px;
    }

    div {
      text-align: center;
    }

    h3 {
      font-size: 20px;
      margin: 20px 0;
    }
    .author {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      span img:nth-of-type(1) {
        width: 30px;
        height: auto;
        margin-left: 0;
      }
      img {
        vertical-align: middle;
        margin: 0 10px;
      }
      a {
        color: #999999;
        font-size: 14px;
      }
      > span:nth-of-type(2) {
        color: #999999;
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>